export default __webpack_public_path__ + "static/media/sort-list-blue.50f27c0e.svg";